import Swiper from "../../../vendors/swiper.min";
import { getMediaQ } from "../../plugins/mediaQ";
import { getParameterByName, getParameters } from "../helpers/getParameter";

export class Tab {
	constructor(tabDomEl, type) {
		// alert('created tab');

		this.tabEl = tabDomEl;
		this.paramName = tabDomEl.getAttribute("data-paramName");
		this.tabsType = type;
		this.noSwiper = this.tabEl.classList.contains("tabs-noswiper");

		switch (type) {
			case "offer":
				this.noSwiper = true;
				this.buildOfferTabs();
				break;
			case "action":
				this.buildActionTabs();
				break;
			default:
				this.buildTabs();
				break;
		}
	}

	// offer tab

	buildOfferTabs() {
		this.tabs = this.tabEl.querySelectorAll("[data-taboffer]");
		this.tabsCont = this.tabEl.querySelector("[data-tabsoffer-cont]");
		this.tabsGroup = this.tabEl.querySelector("[data-tabsoffer-group]");

		if (this.paramName) {
			const param = getParameterByName(this.paramName);
			if (param && param != "") {
				this.tabParam = getParameterByName(this.paramName);
			}
		}

		[].forEach.call(this.tabs, (tab, i) => {
			if (this.tabs.length > 1) {
				tab.setAttribute("aria-controls", "paneloffer" + i);
			} else {
				tab.removeAttribute("aria-controls");
				tab.removeAttribute("aria-selected");
			}
			tab.setAttribute("data-taboffer", i);

			const tabPanel = tab.querySelector("[data-taboffer-panel]");
			if (tabPanel) {
				tabPanel.setAttribute("data-taboffer-panel", i);
				tabPanel.setAttribute("id", "paneloffer" + i);
				this.tabsCont.appendChild(tabPanel);
			}

			if (tab.hasAttribute("data-active-tab")) {
				this.activeTab = tab;
			}
		});

		if (this.tabParam) {
			const paramTab = this.tabEl.querySelector(
				'[data-taboffer][data-param="' + this.tabParam + '"]'
			);
			if (paramTab) this.activeTab = paramTab;
		}

		[].forEach.call(this.tabs, tab => {
			tab.addEventListener("click", e => {
				const el = e.currentTarget;
				if (!el.getAttribute("href") || el.getAttribute("href").length == 0) {
					e.preventDefault();
					this.switchOfferTab(el);
				}
			});

			tab.addEventListener("keypress", e => {
				if (e.keyCode === 0 || e.keyCode === 32 || e.keyCode === 13) {
					const el = e.currentTarget;
					if (!el.getAttribute("href") || el.getAttribute("href").length == 0) {
						e.preventDefault();
						this.switchOfferTab(el);
					}
				}
			});
		});

		if (this.noSwiper) {
			this.widthCheck(true);

			this.tabsGroup.addEventListener("scroll", e => {
				this.widthCheck(false);
			});
		}

		if (this.activeTab) {
			this.switchOfferTab(this.activeTab);
			// $( this.activeTab ).trigger( "click" );
			// this.activeTab.click();
		}

		this.refresh();
	}

	switchOfferTab(clickedTab) {
		let clickedTab_index = clickedTab.getAttribute("data-taboffer");

		if (this.activeTab) {
			this.activeTab.setAttribute("aria-selected", false);
			this.activeTab.classList.remove("active");
		}
		this.activeTab = clickedTab;
		this.activeTab.classList.add("active");
		this.activeTab.setAttribute("aria-selected", true);

		if (this.activeCont) {
			this.activeCont.classList.remove("active");
		}
		this.activeCont = this.tabsCont.querySelector('[data-taboffer-panel="' + clickedTab_index + '"]');
		if (this.activeCont) this.activeCont.classList.add("active");

		if (this.paramName) this.setHistory(clickedTab);

		if (this.tabs.length == 1) {
			this.activeTab.removeAttribute("aria-controls");
			this.activeTab.removeAttribute("aria-selected");
		}
	}

	// basic tabs (with dropdown and swiper)

	buildTabs() {
		this.tabs = this.tabEl.querySelectorAll("[data-tab]");
		this.tabsCont = this.tabEl.querySelector("[data-tabs-cont]");
		this.tabsGroup = this.tabEl.querySelector("[data-tabs-group]");
		this.activeLi = this.tabEl.querySelector("[data-tab-active]");
		this.jq_group = $(this.tabsGroup);

		[].forEach.call(this.tabs, (tab, i) => {
			tab.setAttribute("aria-controls", "panel" + i);
			tab.setAttribute("data-tab", i);

			const tabPanel = tab.querySelector("[data-tab-panel]");
			tabPanel.setAttribute("data-tab-panel", i);
			tabPanel.setAttribute("id", "panel" + i);

			this.tabsCont.appendChild(tabPanel);

			//data-active-tab
			if (i == this.tabsGroup.getAttribute("data-tabs-group")) {
				this.switchTab(tab);
			}
		});

		this.tabType = this.tabEl.getAttribute("data-tabs-module");
		this.initSwitcherTabs();
	}

	initSwitcherTabs() {
		this.tabsSwiper = null;
		this.tabsUl = this.tabsGroup.querySelector("ul");
		this.tabsWidth = 0;

		//if(getMediaQ() != 'mob'){
		this.tabsSwiper = new Swiper(this.tabsGroup, {
			slidesPerView: "auto",
			touchRatio: 1,
			a11y: {
				prevSlideMessage: this.tabsGroup.getAttribute("data-prev-slide-message")
					? this.tabsGroup.getAttribute("data-prev-slide-message")
					: "Poprzednie kategorie",
				nextSlideMessage: this.tabsGroup.getAttribute("data-next-slide-message")
					? this.tabsGroup.getAttribute("data-next-slide-message")
					: "Następne kategorie",
			},
			keyboard: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			on: {
				init: function () {
					setTimeout(() => {
						this.navigation.nextEl.removeAttribute("tabindex");
						this.navigation.nextEl.removeAttribute("role");
						this.navigation.nextEl.removeAttribute("aria-disabled");
						this.navigation.prevEl.removeAttribute("tabindex");
						this.navigation.prevEl.removeAttribute("role");
						this.navigation.prevEl.removeAttribute("aria-disabled");
					}, 10);
				},
			},
		});

		// this.tabsGroup.addEventListener('keydown', (e) => {
		//     if (e.keyCode==9) this.tabsGroup.scrollLeft = 0;
		// });
		this.tabsGroup.addEventListener("keyup", (e) => {
			if (e.keyCode == 9) this.tabsGroup.scrollLeft = 0;
		});
		// }

		[].forEach.call(this.tabs, (tab) => {
			tab.addEventListener("click", (e) => {
				this.switchTab(e.target);
				if (getMediaQ() == "mob") {
					$("[data-tabs-group]").slideUp();
				}
			});

			tab.addEventListener("keypress", e => {
				if (e.keyCode === 0 || e.keyCode === 32 || e.keyCode === 13) {
					this.switchTab(e.target);
				}
			});
		});

		this.activeLi.addEventListener("click", e => {
			let that = e.target;
			if (that.classList.contains("active")) {
				that.classList.remove("active");
				this.jq_group.slideUp();
			} else {
				that.classList.add("active");
				this.jq_group.slideDown();
			}
		});

		this.refresh();
	}

	switchTab(clickedTab) {
		let clickedTab_index = clickedTab.getAttribute("data-tab");

		if (this.activeTab) {
			this.activeTab.setAttribute("aria-selected", false);
			this.activeTab.classList.remove("active");
		}
		this.activeTab = clickedTab;
		clickedTab.classList.add("active");
		clickedTab.setAttribute("aria-selected", true);
		if (this.activeCont) {
			this.activeCont.classList.remove("active");
		}
		this.activeCont = this.tabsCont.querySelector(
			'[data-tab-panel="' + clickedTab_index + '"]'
		);
		this.activeCont.classList.add("active");

		if (getMediaQ() == "mob") {
			if (this.activeLi.classList.contains("active"))
				this.activeLi.classList.remove("active");
			this.activeLi.innerHTML = clickedTab.innerHTML;
			this.jq_group.slideUp();
		}
	}

	// action tabs: small with swiper

	buildActionTabs() {
		this.tabs = this.tabEl.querySelectorAll("[data-tab]");
		this.tabsGroup = this.tabEl.querySelector("[data-tabs-group]");

		if (this.paramName) {
			const param = getParameterByName(this.paramName);
			if (param && param != "") {
				this.tabParam = getParameterByName(this.paramName);
			}
		}

		this.tabsCont = this.tabEl.querySelector("[data-tabs-cont]");
		// this.jq_group = $(this.tabsGroup);

		[].forEach.call(this.tabs, (tab, i) => {
			let ind = tab.getAttribute("data-tab");

			if (!ind || ind.length === 0) {
				ind = i; // TODO: ma wpływ na logikę komponentu filterCategories/index.js
			}

			// if (!ind && ind != "") ind = i;

			tab.setAttribute("data-tab", ind);

			const tabPanel = tab.querySelector("[data-tab-panel]");
			if (tabPanel) {
				tabPanel.setAttribute("data-tab-panel", ind);
				tabPanel.setAttribute("id", "panel" + ind);

				this.tabsCont.appendChild(tabPanel);
			}

			if (tab.hasAttribute("data-active-tab")) {
				this.activeTab = tab;
			}
		});

		if (this.tabParam) {
			const paramTab = this.tabEl.querySelector(
				'[data-tab][data-param="' + this.tabParam + '"]'
			);
			if (paramTab) this.activeTab = paramTab;
		}

		if (this.activeTab) this.switchActionTab(this.activeTab);

		// this.tabType = this.tabEl.getAttribute('data-tabs-module');
		this.initActionTabs();
	}

	initActionTabs() {
		this.tabsSwiper = null;
		this.tabsUl = this.tabsGroup.querySelector("ul");
		this.tabsWidth = 0;
		if (!this.noSwiper) {
			this.tabsSwiper = new Swiper(this.tabsGroup, {
				slidesPerView: "auto",
				touchRatio: 1,
				a11y: {
					prevSlideMessage: this.tabsGroup.getAttribute("data-prev-slide-message")
						? this.tabsGroup.getAttribute("data-prev-slide-message")
						: "Poprzednie kategorie",
					nextSlideMessage: this.tabsGroup.getAttribute("data-next-slide-message")
						? this.tabsGroup.getAttribute("data-next-slide-message")
						: "Następne kategorie",
				},
				keyboard: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				on: {
					init: function () {
						setTimeout(() => {
							this.navigation.nextEl.removeAttribute("tabindex");
							this.navigation.nextEl.removeAttribute("role");
							this.navigation.nextEl.removeAttribute("aria-disabled");
							this.navigation.prevEl.removeAttribute("tabindex");
							this.navigation.prevEl.removeAttribute("role");
							this.navigation.prevEl.removeAttribute("aria-disabled");
						}, 10);
					},
				},
			});
			this.tabsSwiper.navigation.prevEl.addEventListener("mousedown", e => {
				this.tabsSwiper.update();
			});
		}	

		this.tabsGroup.addEventListener("keyup", (e) => {
			if (e.keyCode == 9) this.tabsGroup.scrollLeft = 0;
		});

		[].forEach.call(this.tabs, (tab) => {
			tab.addEventListener("click", (e) => {
				const el = e.currentTarget;
				if (el.childNodes[0].tagName != "A") {
					this.switchActionTab(el);
				}
			});

			tab.addEventListener("keypress", (e) => {
				if (e.keyCode === 0 || e.keyCode === 32 || e.keyCode === 13) {
					const el = e.currentTarget;
					if (el.childNodes[0].tagName != "A") {
						this.switchActionTab(el);
					}
				}
			});
		});

		if (this.noSwiper) {
			const el = this.tabsGroup.querySelector("ul");
			const li_first = el.querySelector("li");
			const li_last = el.querySelector("li:last-child");

			this.widthCheck(true, el, li_first, li_last);

			el.addEventListener("scroll", (e) => {
				this.widthCheck(false, el, li_first, li_last);
			});
		}
	}

	widthCheck(firstTime, el, li_first, li_last) {
		if (el == null && li_first == null && li_last == null) {
			el = this.tabsGroup;
			li_first = el.querySelector("[data-taboffer]");
			li_last = el.querySelector("[data-taboffer]:last-child");
		}

		if (li_first) {
			const bcr_1 = li_first.getBoundingClientRect();
			const bcr_2 = li_last.getBoundingClientRect();
			const bcr_w = el.getBoundingClientRect();

			if (!firstTime && bcr_1.left + 1 < bcr_w.left) {
				this.tabEl.classList.add("left-shadow");
			} else {
				this.tabEl.classList.remove("left-shadow");
			}

			if (bcr_2.right - 1 > bcr_w.right) {
				this.tabEl.classList.add("right-shadow");
			} else {
				this.tabEl.classList.remove("right-shadow");
			}
		}
	}

	switchActionTab(clickedTab) {
		if (this.tabsSwiper) {
			var nodes = Array.prototype.slice.call(clickedTab.parentNode.children);
			var index = nodes.indexOf(clickedTab);
			this.tabsSwiper.activeIndex = index;
			this.tabsSwiper.slideTo(index);
			if (index !== 0 && index !== this.tabsSwiper.slides.length - 1) {
				this.tabsSwiper.setTranslate(-clickedTab.offsetLeft + 50);
			}
		}

		let clickedTab_index = clickedTab.getAttribute("data-tab");

		if (this.activeTab) {
			this.activeTab.setAttribute("aria-selected", false);
			this.activeTab.classList.remove("active");
		}
		this.activeTab = clickedTab;
		clickedTab.classList.add("active");
		clickedTab.setAttribute("aria-selected", true);

		if (this.tabsCont) {
			if (this.activeCont) this.activeCont.classList.remove("active");
			this.activeCont = this.tabsCont.querySelector('[data-tab-panel="' + clickedTab_index + '"]');
			if (this.activeCont) this.activeCont.classList.add("active");
		}

		if (this.paramName) this.setHistory(clickedTab);
	}

	setHistory(tab) {
		let actParams = getParameters();

		const tabParam = tab.getAttribute("data-param");
		if (tabParam && tabParam != "") {
			actParams[this.paramName] = tabParam;

			let search = "?";
			for (let prop in actParams) {
				search += prop + "=" + actParams[prop] + "&";
			}
			search = search.slice(0, -1);

			if (search.length > 1) {
				history.pushState(null, null, search);
			}
		}
	}

	refresh() {
		if (this.tabsType == "basic") {
			this.onWidthChange();
			this.tabsSwiper.update();
		}
		if (this.tabsType == "action") {
			if (this.tabsSwiper) this.tabsSwiper.update();
		}
		if (this.tabsType == "offer") {
			this.widthCheck(true);
		}
	}

	onWidthChange() {
		// let mainWidth = document.body.clientWidth
		this.tabsWidth = 0;
		[].forEach.call(this.tabs, tab => {
			this.tabsWidth += tab.offsetWidth;
		});

		if (getMediaQ() != "mob") {
			this.tabsGroup.style.display = "";

			if (this.tabsUl.offsetWidth <= this.tabsWidth) {
				this.tabsUl.style.justifyContent = "left";
			} else {
				this.tabsUl.style.justifyContent = "center";
			}
		} else {
			this.tabsUl.style.transform = "";
			this.tabsGroup.style.display = "";
			this.tabEl.querySelector("[data-tab-active]").classList.remove("active");
		}
	}
}
